export default __webpack_public_path__ + "static/B0216-608df526617e0a3d17c9c393e9bbf00d.png";